
import CardLoading from "../common/CardLoading.vue";
export default {
  props: {
    videoData: {
      type: Array,
      default: []
    },
    redirectPage: {
      type: String,
      default: "",
    },
    xl: {
      type: Number,
      default: ""
    },
    lg: {
      type: Number,
      default: ""
    },
    md: {
      type: Number,
      default: ""
    },
    sm: {
      type: Number,
      default: ""
    },
    isEmptyPage: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    renderViewsList(video) {
      const int = video.extendInfo && video.extendInfo.views
      return int ? parseInt(int) : 0;
    }
  },
  components: { CardLoading },
}
